import * as React from 'react';
import CompareIcon from '@mui/icons-material/Compare';
import { Translate } from '../../../../../../../shared/LanguageService';
import { ImageSelectionToolbar } from '../../../shared/selection/view/ImageSelectionToolbar';

type CompareImagesButtonProps = {
    onCompare: () => void;
    onCancel: () => void;
    onSelectStart: () => void;
    isCompareEnabled: boolean;
};

export function CompareImagesButton({
    onCompare,
    onCancel,
    onSelectStart,
    isCompareEnabled
}: CompareImagesButtonProps) {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const handleSelectClick = () => {
        setIsExpanded(true);
        onSelectStart();
    };

    const handleCancel = () => {
        setIsExpanded(false);
        onCancel();
    };

    return (
        <ImageSelectionToolbar
            isSelecting={isExpanded}
            onSelectStart={handleSelectClick}
            onCancel={handleCancel}
            selectTooltip={Translate('image-processing/button-tooltip/select-many/info')}
            actions={[
                {
                    label: Translate('order/image-processing/button-toolbar/button/compare'),
                    icon: <CompareIcon />,
                    onClick: onCompare,
                    disabled: !isCompareEnabled,
                    disabledTooltip: Translate(
                        'order/image-processing/button-toolbar/tooltip/compare-disabled'
                    )
                }
            ]}
        />
    );
}
